<template>
  <div id="app">
      <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss">
#app {
  margin: 0 auto;
  overflow: hidden;
}
.customHeightSelect input{
  height:50px;
}
.customSwitch{
  margin-left: 5px;
  vertical-align: baseline;
}
.customSwitch .el-switch__label{
  color:#ccc;
}
.customSwitch .el-switch__label.is-active{
  color:#333;
}
.goods_info_row .el-input__inner{
  height:50px;
}
.customDialog .el-dialog__body{
  padding:0;
}
.customDialog1 .el-dialog__body{
  padding:15px 50px 30px !important;
}
.customheight_auto .el-input__inner{
    height:50px !important;
    line-height: 50px;
  }
.el-loading-mask{
  background:transparent
}
.el-loading-spinner{
  padding-left:3px !important;
}
.el-loading-spinner .path{
  stroke:black !important;
}
.el-loading-spinner .circular{
  width:15px !important;
}
.obsolete-price {
  text-decoration: line-through;
  font-size: 12px;
}
.line-end:hover{
    text-decoration-line: underline;
  }
a {
  cursor:pointer;
}
</style>



// WEBPACK FOOTER //
// src/App.vue